export default __webpack_public_path__ + "static/output-78e03790d1b48a398437b82a65c91356.mp4";